import * as ast from 'notebook/tables/excess/AST';
import {
  Environment,
  MultiDocSpreadsheetEvaluator,
  SingleDocSpreadsheetEvaluator,
} from 'notebook/tables/excess/Evaluator';
import FormulaUtil from 'notebook/tables/excess/FormulaUtil';
import {functions} from 'notebook/tables/excess/functions';
import FillDown from 'notebook/tables/excess/ops/fillDown';
import paste from 'notebook/tables/excess/ops/paste';
import {
  deleteColumns,
  deleteRows,
  deleteRowsNonContiguous,
  insertColumnsLeft,
  insertColumnsRight,
  insertRowsAbove,
  insertRowsBelow,
  mergeRegion,
  renameTable,
  reorderRowsOrColumns,
  unmergeRegion,
  mergeIntoSingleInput,
  unmergeSingleInput,
  wrapTableOpForSingleDoc,
} from 'notebook/tables/excess/ops/TableOps';
import parser from 'notebook/tables/excess/Parser';
import tokenizer from 'notebook/tables/excess/Tokenizer';
import * as util from 'notebook/tables/excess/Util';

const {fillDown} = FillDown;

export default {
  // When bumping EXCESS_VERSION, describe the changes in EXCESS_CHANGELOG.md
  EXCESS_VERSION: '2025-09-09',
  Environment,
  SpreadsheetEvaluator: SingleDocSpreadsheetEvaluator,
  MultiDocSpreadsheetEvaluator,
  parser,
  parse: parser.parse,
  util,
  functions,
  tokenizer,
  ast,
  ops: {
    deleteColumns,
    deleteRows,
    deleteRowsNonContiguous,
    fillDown,
    insertColumnsLeft,
    insertColumnsRight,
    insertRowsAbove,
    insertRowsBelow,
    reorderRowsOrColumns,
    renameTable,
    mergeRegion,
    unmergeRegion,
    mergeIntoSingleInput,
    unmergeSingleInput,
    paste,
    wrapTableOpForSingleDoc,
  },
  FormulaUtil,
};
